import { render } from "./UserCardSimple.vue?vue&type=template&id=3867395a"
import script from "./UserCardSimple.vue?vue&type=script&lang=js"
export * from "./UserCardSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__